export const AccountReducer = (state = {}, action) => {
    switch (action.type) {
        case "CREATE_ACCOUNT":
            console.log("create account with " + action.payload.msisdn);
            return state = action.payload;
        case "UPDATE_ACCOUNT":
            return action.payload;
        default:
            return state;
    }
}

export default AccountReducer;